export default __webpack_public_path__ + "images/dollar_02c0b8.svg";